interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded ${className}`}
      style={{ background: 'var(--bg-skeleton)' }}
    />
  );
}

export function PostSkeleton() {
  return (
    <div className="social-box rounded overflow-hidden">
      <div className="p-3 space-y-2.5">
        <div className="flex items-center gap-2.5">
          <Skeleton className="w-9 h-9 rounded-full" />
          <div className="space-y-1">
            <Skeleton className="w-28 h-3" />
            <Skeleton className="w-16 h-2.5" />
          </div>
        </div>
        <Skeleton className="w-full h-3" />
        <Skeleton className="w-3/4 h-3" />
        <div className="flex gap-3 pt-1">
          <Skeleton className="w-14 h-5 rounded-full" />
          <Skeleton className="w-14 h-5 rounded-full" />
          <Skeleton className="w-14 h-5 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function ProfileSkeleton() {
  return (
    <div className="social-box rounded overflow-hidden">
      <div className="p-4 space-y-3">
        <div className="flex items-center gap-4">
          <Skeleton className="w-20 h-20 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="w-40 h-5" />
            <Skeleton className="w-24 h-3" />
          </div>
        </div>
        <Skeleton className="w-full h-14" />
      </div>
    </div>
  );
}
